<template>
    <div>
        <button 
            v-if="user_role != 'manager' && user_role != 'moderator' && add_monitor_btn == true" 
            @click="AddMonitor"
            :class="[btn_class, iconOnly ? 'add-monitor-btn-icon' : '']"
            :title="iconOnly ? 'Add New Monitor' : ''"
        >
            <img v-if="iconOnly" src="../assets/icons/Add-monitor-short.svg" alt="Add Monitor" class="add-monitor-icon" />
            <template v-else>
                <img src="../assets/icons/Add-monitor-short.svg" alt="Add Monitor" class="add-monitor-icon" />
                Add Monitor
            </template>
        </button>
    </div>
</template>
<script>
export default {
    props: {
        iconOnly: {
            type: Boolean,
            default: false
        },
        variant: {
            type: String,
            default: 'green', // 'green' or 'dark'
            validator: value => ['green', 'dark'].includes(value)
        }
    },
    data() {
        return {
            user_role: '',
            add_monitor_btn: false,
            btn_class: 'add-monitor-btn-green'
        }
    },
    mounted() {
        let user = JSON.parse(window.localStorage.getItem('userinfo'))
        this.user_role = user.role
        
        // Use prop variant if provided, otherwise use route-based logic
        if (this.variant) {
            this.btn_class = this.variant === 'green' ? 'add-monitor-btn-green' : 'add-monitor-btn-dark';
        } else {
            let pathName = this.$route.name
            if (pathName === 'Dashboard' || pathName === 'Incidents' || pathName === 'Referral' || pathName === 'Profile') {
                this.btn_class = 'add-monitor-btn-green';
            } else {
                this.btn_class = 'add-monitor-btn-dark';
            }
        }

        if (this.$router.history.current.path !== '/app/monitor') {
            this.add_monitor_btn = true;
        }
    },
    methods: {
        AddMonitor() {
            this.$root.$data.showAddMoinitor = true;
            this.$router.push("/app/monitor");
        },
    }
}
</script>

<style scoped>
.add-monitor-icon {
  width: 20px;
  height: 20px;
}
</style>